import {Component, Input, OnInit} from '@angular/core';
import {Customer} from '../../customers/data/customer';
import {UserDto} from '../../user/data/userDto';
import {ISelectOption} from '../../_widget-library/fields/single-select/single-select.component';
import {FlagColor} from '../../flag/data/flagColor';
import {LeadDto} from '../../communication/data/requests/leadDto';
import {Communication} from '../../communication/data/communication';
import {CommunicationService} from '../../communication/services/communication.service';
import {MessageService} from 'primeng/api';
import {AppointmentDto} from '../../appointment/data/appointmentDto';
import {AppointmentService} from '../../appointment/services/appointment.service';
import {Tab} from '../../tabbing/data/tab';
import {SnippetService} from '../../snippet/services/snippet/snippet.service';
import {GenericVersion} from '../../audit/data/GenericVersion';
import {SnippetDto} from '../../snippet/data/snippetDto';
import {ElectronService} from 'ngx-electron';


@Component({
  selector: 'app-testing-page',
  templateUrl: './testing-page.component.html',
  styleUrls: ['./testing-page.component.scss']
})
export class TestingPageComponent implements OnInit {
  @Input() tab: Tab;

  text: string = 'text';
  number: number = 20;
  date: Date = new Date();
  selectedValue = 'Option 1';
  selectables: string[] = ['Option 1', 'Option 2', 'Option 3'];
  customer: Customer = new Customer();
  worker: UserDto = new UserDto();
  bool: boolean = true;
  singleSelectValue: string;
  singleSelectables: ISelectOption[] = [
    {name: undefined, icon: 'fa-globe', color: undefined, value: '1'},
    {name: 'B', icon: undefined, color: undefined, value: '2'},
    {name: 'C', icon: 'fa-user', color: undefined, value: '3'}
  ];
  multiSelectValue: string[];
  multiSelectables: ISelectOption[] = [
    {name: undefined, icon: 'fa-globe', color: undefined, value: '1'},
    {name: 'B', icon: undefined, color: undefined, value: '2'},
    {name: 'C', icon: 'fa-user', color: undefined, value: '3'}
  ];
  flagValue: FlagColor = FlagColor.Purple;
  flagValues: FlagColor[] = [FlagColor.None, FlagColor.Purple, FlagColor.Orange];


  lead: LeadDto = new LeadDto();
  newLead = {value: true};
  comm: Communication = new Communication();

  appointmentDto: AppointmentDto;

  // snippetAuditList: GenericVersion[];
  // snippetDto: SnippetDto;
  // showAudits: boolean = false;

  constructor(public commService: CommunicationService,
              public messageService: MessageService,
              public appointmentService: AppointmentService,
              public snippetService: SnippetService,
              public electronService: ElectronService) { }

  async ngOnInit(): Promise<void> {
    this.lead = this.generateDummyLeadDTO();
    this.comm = this.commService.getDummyCommunication();
    // this.snippetDto = await this.getSnippet();
  }

  generateDummyLeadDTO() {
    const lead = new LeadDto();
    lead.name = '';
    lead.email = '';
    lead.phoneNumber = '';
    lead.notes = '';
    return lead;
  }

  generateEml(): void {
    const data = {
      // from: 'no-reply@bar.com',
      to: {
        name: 'George',
        email: 'george.r@rzprod.com'
      },
      subject: 'Winter promotions',
      html: '<html><head></head><body><b>Lorem ipsum...</b><br /><img src="nodejs.png" alt="" /></body></html>'
    };

    this.electronService.ipcRenderer.send('generate-eml', {eml: data});
  }

  cons($event: any) {
    console.log($event);
  }

  dropdownSelect(value: any) {
    this.selectedValue = value;
  }

  singleSelect(value: any) {
    this.singleSelectValue = value;
  }

  multiSelect(value: any) {
    this.multiSelectValue = value;
  }

  async notify1(): Promise<void> {
    this.messageService.clear();
    await this.appointmentService.getAppointmentById(6).then(result => {
      this.messageService.add({
        key: 'appointment',
        severity: 'custom-1',
        summary: 'Appointment Test - 12:30 PM',
        detail: '30',
        closable: false,
        contentStyleClass: 'p-0',
        sticky: true,
        data: result
      });
    });
  }

  // async popAudits(): Promise<void>{
  //   this.snippetAuditList = await this.snippetService.getSnippetHistory(192);
  //   this.showAudits = true;
  // }
  //
  // async getSnippet(): Promise<SnippetDto> {
  //   return await this.snippetService.getSnippet(192, false);
  // }
  //
  // async getSnippetVersion(event): Promise<void> {
  //   this.snippetDto = await this.snippetService.getSnippetVersion(event.tableKeys, event.id);
  //   // console.log(this.auditList);
  // }
  //
  // async revertSnippet(): Promise<void> {
  //   await this.snippetService.editSnippet(this.snippetDto, false);
  // }

  clear(key: string) {
    this.messageService.clear(key);
  }

}
